// extracted by mini-css-extract-plugin
export default {"task_number":"week-schedule_task_number__MRxru","task_name":"week-schedule_task_name__vtUig","task_status":"week-schedule_task_status__pltC0","today":"week-schedule_today__Dz9lE"};